import React, { Fragment, useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import sicon1 from "../../icons/icon_google.svg";
import appleIcon from "../../icons/Apple_icon.png";
import coinIcon from "../../images/site_logo/TC-Logo-icon.png";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./style.css";
import { API_URL } from "../../constant";
import { FaEye, FaEyeSlash, FaLink, FaCopy, FaShareAlt, FaSearch, FaFilter, FaSpinner } from "react-icons/fa";
import { IoArrowForward, IoArrowBack } from "react-icons/io5";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const walletWindowRef = useRef(null);

  // State for referral code
  const [referralCode, setReferralCode] = useState(null);
  // State for login data
  const [loginData, setLoginData] = useState(null);
  // Ref for auto-dismiss timeout
  const autoDismissRef = useRef(null);

  // Senior Agents state
  const [seniorAgents, setSeniorAgents] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoSliding, setIsAutoSliding] = useState(true);
  const [isLoadingAgents, setIsLoadingAgents] = useState(true);
  const [agentsError, setAgentsError] = useState(null);
  const [filters, setFilters] = useState({
    per_page: 20,
    page: 1,
    country: '',
    region: '',
    search: '',
    sort_by: 'created_at',
    sort_order: 'asc'
  });
  const [availableFilters, setAvailableFilters] = useState({
    countries: [],
    regions: []
  });
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  
  const slideIntervalRef = useRef(null);

  // Function to fetch senior agents from API
  const fetchSeniorAgents = useCallback(async () => {
    try {
      setIsLoadingAgents(true);
      setAgentsError(null);
      
      // Build query parameters
      const queryParams = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== '' && filters[key] !== 'all') {
          queryParams.append(key, filters[key]);
        }
      });

      const url = `${API_URL}/api/senior-customer-advertising-agents/public${
        queryParams.toString() ? `?${queryParams.toString()}` : ''
      }`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Format agents for UI
      const colors = ['#2D4CA8', '#9F4AFF', '#FF6B6B', '#4CAF50', '#FF9800', '#9C27B0', '#2196F3', '#FF5722'];
      const formattedAgents = data.agents.map(agent => {
        // Generate QR code URL for the referral link
        const referralLink = `${window.location.origin}/create-account?ref=${agent.agent_code}`;
        const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(referralLink)}`;
        
        // Generate a color based on agent ID for UI consistency
        const colorIndex = agent.agent_id ? (agent.agent_id % colors.length) : 0;
        
        return {
          id: agent.agent_id || agent.customer_id,
          customer_id: agent.customer_id,
          agent_id: agent.agent_id,
          fullName: agent.full_name || `${agent.first_name} ${agent.last_name}`,
          firstName: agent.first_name,
          lastName: agent.last_name,
          location: agent.country || 'Unknown',
          region: agent.region,
          position: agent.position || 'Senior Customer Advertising Agent',
          referralLink: referralLink,
          qrCode: qrCodeUrl,
          profilePic: agent.profile_image || 'https://randomuser.me/api/portraits/men/75.jpg',
          color: colors[colorIndex],
          email: agent.email,
          phoneNumber: agent.phone_number,
          memberSince: agent.member_since,
          agentSince: agent.agent_since,
          isActive: agent.is_active,
          agentCode: agent.agent_code,
        };
      });
      
      setSeniorAgents(formattedAgents);
      setAvailableFilters({
        countries: data.available_filters?.countries || [],
        regions: data.available_filters?.regions || []
      });
      
      // Reset slide to 0 when new data loads
      setCurrentSlide(0);
    } catch (error) {
      console.error('Failed to fetch senior agents:', error);
      setAgentsError('Failed to load senior agents. Showing sample data instead.');
      
      // Fallback to dummy data if API fails
      const fallbackData = [
        {
          id: 1,
          fullName: "Era Morgan",
          location: "UK",
          position: "Senior Customer Advertising Agent",
          referralLink: "https://topcoinuk.com/create-account?ref=6321",
          qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://topcoinuk.com/create-account?ref=6321",
          profilePic: "https://randomuser.me/api/portraits/women/65.jpg",
          color: "#2D4CA8",
        },
        {
          id: 2,
          fullName: "Malcolm Summers",
          location: "Sri Lanka",
          position: "Senior Customer Advertising Agent",
          referralLink: "https://topcoinuk.com/create-account?ref=2116",
          qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://topcoinuk.com/create-account?ref=2116",
          profilePic: "https://randomuser.me/api/portraits/men/32.jpg",
          color: "#9F4AFF",
        },
        {
          id: 3,
          fullName: "Kathy Godridge",
          location: "Switzerland",
          position: "Senior Customer Advertising Agent",
          referralLink: "https://topcoinuk.com/create-account?ref=1234",
          qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://topcoinuk.com/create-account?ref=1234",
          profilePic: "https://randomuser.me/api/portraits/women/44.jpg",
          color: "#FF6B6B",
        },
        {
          id: 4,
          fullName: "Alex Johnson",
          location: "Australia",
          position: "Senior Customer Advertising Agent",
          referralLink: "https://topcoinuk.com/create-account?ref=3215",
          qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://topcoinuk.com/create-account?ref=3215",
          profilePic: "https://randomuser.me/api/portraits/men/67.jpg",
          color: "#4CAF50",
        },
        {
          id: 5,
          fullName: "Sarah Williams",
          location: "Germany",
          position: "Senior Customer Advertising Agent",
          referralLink: "https://topcoinuk.com/create-account?ref=4521",
          qrCode: "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://topcoinuk.com/create-account?ref=4521",
          profilePic: "https://randomuser.me/api/portraits/women/33.jpg",
          color: "#FF9800",
        },
      ];
      setSeniorAgents(fallbackData);
      setAvailableFilters({
        countries: ['UK', 'Sri Lanka', 'Switzerland', 'Australia', 'Germany'],
        regions: ['Europe', 'Asia', 'Australia']
      });
    } finally {
      setIsLoadingAgents(false);
    }
  }, [filters]);

  // Initialize sliding interval with condition for minimum cards on large devices
  useEffect(() => {
    // Check if we should auto-slide
    const shouldAutoSlide = isAutoSliding && 
                          seniorAgents.length > 0 && 
                          (!window.matchMedia('(min-width: 992px)').matches || seniorAgents.length >= 3);

    if (shouldAutoSlide) {
      slideIntervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % seniorAgents.length);
      }, 4000);
    } else if (slideIntervalRef.current) {
      // Clear interval if conditions not met
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }

    return () => {
      if (slideIntervalRef.current) {
        clearInterval(slideIntervalRef.current);
      }
    };
  }, [isAutoSliding, seniorAgents.length]);

  // Fetch agents on component mount and when filters change
  useEffect(() => {
    fetchSeniorAgents();
  }, [fetchSeniorAgents]);

  // Initialize referral code from URL or localStorage on component mount
  useEffect(() => {
    // Get referral code from URL parameter
    const params = new URLSearchParams(window.location.search);
    const urlRef = params.get("ref");

    if (urlRef) {
      // Store in localStorage for persistence
      localStorage.setItem("login_referral_code", urlRef);
      setReferralCode(urlRef);
      console.log("Referral code from URL (login):", urlRef);
    } else {
      // Check if we have a stored referral code
      const storedRef = localStorage.getItem("login_referral_code");
      if (storedRef) {
        setReferralCode(storedRef);
        console.log("Referral code from localStorage (login):", storedRef);
      }
    }
  }, []);

  // Handle card click - open referral link
  const handleCardClick = (link) => {
    window.open(link, "_blank");
  };

  // Handle copy referral link
  const handleCopyLink = (link, e) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(link)
      .then(() => {
        alert("Referral link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // Handle share referral link
  const handleShareLink = (link, e) => {
    e.stopPropagation();
    if (navigator.share) {
      navigator
        .share({
          title: "Join TopCoin UK",
          text: "Join TopCoin UK using my referral link!",
          url: link,
        })
        .catch(console.error);
    } else {
      handleCopyLink(link, e);
    }
  };

  // Handle next slide with device check
  const handleNextSlide = () => {
    setIsAutoSliding(false);
    setCurrentSlide((prev) => (prev + 1) % seniorAgents.length);
    
    // Only resume auto-sliding if on mobile or if there are enough cards on desktop
    const shouldResume = !window.matchMedia('(min-width: 992px)').matches || seniorAgents.length >= 3;
    if (shouldResume) {
      setTimeout(() => setIsAutoSliding(true), 5000);
    }
  };

  // Handle previous slide with device check
  const handlePrevSlide = () => {
    setIsAutoSliding(false);
    setCurrentSlide(
      (prev) => (prev - 1 + seniorAgents.length) % seniorAgents.length
    );
    
    // Only resume auto-sliding if on mobile or if there are enough cards on desktop
    const shouldResume = !window.matchMedia('(min-width: 992px)').matches || seniorAgents.length >= 3;
    if (shouldResume) {
      setTimeout(() => setIsAutoSliding(true), 5000);
    }
  };

  // Handle dot click with device check
  const handleDotClick = (index) => {
    setIsAutoSliding(false);
    setCurrentSlide(index);
    
    // Only resume auto-sliding if on mobile or if there are enough cards on desktop
    const shouldResume = !window.matchMedia('(min-width: 992px)').matches || seniorAgents.length >= 3;
    if (shouldResume) {
      setTimeout(() => setIsAutoSliding(true), 5000);
    }
  };

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: 1 // Reset to first page when filters change
    }));
  };

  // Handle search
  const handleSearch = (e) => {
    e.preventDefault();
    fetchSeniorAgents();
  };

  // Reset filters
  const handleResetFilters = () => {
    setFilters({
      per_page: 20,
      page: 1,
      country: '',
      region: '',
      search: '',
      sort_by: 'created_at',
      sort_order: 'desc'
    });
    setShowFilterPanel(false);
    // Don't fetch here - useEffect will trigger automatically
  };

  // Function to open URL in new tab with fallback for different browsers
  const openInNewTab = (url) => {
    try {
      // Try to open with window.open first
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");

      if (newWindow) {
        return newWindow;
      }

      // Fallback for browsers that block window.open
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Return a dummy object to prevent errors
      return { closed: true };
    } catch (error) {
      console.error("Error opening new tab:", error);
      // Last resort - navigate in current window
      window.location.href = url;
      return { closed: true };
    }
  };

  // Function to clear form fields
  const clearFormFields = () => {
    setEmail("");
    setPassword("");
    setPasswordVisible(false);
  };

  // Function to handle dismiss message
  const handleDismissMessage = () => {
    // Clear the auto-dismiss timeout if it exists
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
      autoDismissRef.current = null;
    }
    setMessage({ text: "", type: "" });
    // Also clear login data when dismissing message
    setLoginData(null);
  };

  // Function to clear message after delay
  const clearMessageAfterDelay = (delay = 10000) => {
    // Clear any existing timeout
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
    }

    // Set new timeout
    autoDismissRef.current = setTimeout(() => {
      setMessage({ text: "", type: "" });
      // Also clear login data when message auto-dismisses
      setLoginData(null);
    }, delay);
  };

  // Clean up timeout on component unmount
  useEffect(() => {
    return () => {
      if (autoDismissRef.current) {
        clearTimeout(autoDismissRef.current);
      }
    };
  }, []);

  const handleGoogleLogin = () => {
    // Use the referral code from state (which could be from URL or localStorage)
    const callbackUrl = `${window.location.origin}/auth/google/callback`;
    let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(
      callbackUrl
    )}`;

    // Add referral code to Google OAuth URL if present
    if (referralCode) {
      googleAuthUrl += `&ref=${encodeURIComponent(referralCode)}`;
      localStorage.setItem("pending_oauth_referral", referralCode);
      console.log("🔗 Opening Google OAuth with referral:", referralCode);
    }

    // Set flags for Google OAuth login
    sessionStorage.setItem("just_logged_in", "true");
    localStorage.setItem("just_logged_in_timestamp", Date.now().toString());

    // Open Google OAuth in same tab
    window.location.href = googleAuthUrl;
  };

  const handleAppleLogin = () => {
    window.open(`${API_URL}/api/auth/apple`, "_blank");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    // Clear any existing auto-dismiss timeout
    if (autoDismissRef.current) {
      clearTimeout(autoDismissRef.current);
      autoDismissRef.current = null;
    }

    setIsLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const response = await fetch(`${API_URL}/api/customer/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
          referral_code: referralCode || null,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setMessage({
          text: data.message || "Login failed. Please check your credentials.",
          type: "error",
        });
        clearMessageAfterDelay(10000);
        setIsLoading(false);
        return;
      }

      // Login successful
      localStorage.setItem("auth_token", data.access_token);
      setLoginData(data);

      // Store user data
      localStorage.setItem(
        "user",
        JSON.stringify(
          data.user || {
            name: data.user?.name || email.split("@")[0],
            email: email,
          }
        )
      );

      // Set login flags
      sessionStorage.setItem("just_logged_in", "true");
      localStorage.setItem("just_logged_in_timestamp", Date.now().toString());

      // Clear first login flag
      localStorage.setItem("is_first_login", "false");

      // Clear referral code
      localStorage.removeItem("login_referral_code");

      setMessage({
        text: "Login successful! Your wallet has been opened in a new tab.",
        type: "success",
      });

      // Set auto-dismiss timeout for success message
      clearMessageAfterDelay(15000); // 15 seconds

      // Clear form fields
      clearFormFields();

      // Generate a token key for cross-tab communication
      const tempTokenKey = `customer_temp_token_${Date.now()}`;
      localStorage.setItem(tempTokenKey, data.access_token);

      // Build wallet URL with token parameter
      const walletUrl = `${window.location.origin}/customer/wallet`;

      // First, check if we're in a popup scenario
      const isPopup = window.opener || window.parent !== window;

      if (isPopup) {
        // We're in a popup, so redirect in current window
        window.location.href = walletUrl;
      } else {
        // Open wallet in new tab/window
        const newWindow = openInNewTab(walletUrl);

        // Set a timeout to close and retry if the new tab doesn't get the token
        setTimeout(() => {
          try {
            // Send token to new tab via postMessage if possible
            if (newWindow && newWindow.postMessage) {
              newWindow.postMessage(
                {
                  type: "LOGIN_SUCCESS",
                  token: data.access_token,
                  tempTokenKey: tempTokenKey,
                },
                window.location.origin
              );
            }
          } catch (e) {
            console.log("Could not send message to wallet tab:", e);
          }

          // Clean up temp token after 30 seconds
          setTimeout(() => {
            localStorage.removeItem(tempTokenKey);
          }, 30000);
        }, 500);
      }
    } catch (error) {
      console.error("Login error:", error);
      setMessage({
        text: "Network error. Please check your connection and try again.",
        type: "error",
      });
      clearMessageAfterDelay(10000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key && e.key.startsWith("customer_temp_token_")) {
        // Token was stored by another tab
        const token = localStorage.getItem(e.key);
        if (token) {
          localStorage.setItem("auth_token", token);
          // Navigate to wallet if we're on login page
          if (window.location.pathname.includes("/login")) {
            navigate("/customer/wallet");
          }
        }
      }
    };

    // Listen for storage events (from other tabs)
    window.addEventListener("storage", handleStorageChange);

    // Listen for postMessage events
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data && event.data.type === "LOGIN_SUCCESS") {
        localStorage.setItem("auth_token", event.data.token);
        if (event.data.tempTokenKey) {
          localStorage.removeItem(event.data.tempTokenKey);
        }
        navigate("/customer/wallet");
      }
    };

    window.addEventListener("message", handleMessage);

    // Clean up
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  // Function to open wallet in new tab and refresh current page
  const openWalletInNewTabAndRefresh = () => {
    const walletUrl = `${window.location.origin}/customer/wallet`;

    // Method 1: Try to open in new tab
    const newWindow = window.open(walletUrl, "_blank");

    // Method 2: Fallback for popup blockers
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      // If popup blocked, show message with link
      setMessage({
        text: "Login successful! Popup was blocked. Please click the link below to open your wallet.",
        type: "success",
      });

      // Add manual link to message
      setTimeout(() => {
        const manualLink = document.createElement("a");
        manualLink.href = walletUrl;
        manualLink.target = "_blank";
        manualLink.style.display = "none";
        document.body.appendChild(manualLink);
        manualLink.click();
        document.body.removeChild(manualLink);
      }, 500);
    }
  };

  // Function to handle opening wallet portal
  const handleOpenWallet = () => {
    if (loginData && loginData.access_token) {
      // Reopen wallet with stored token
      const tempTokenKey = `customer_temp_token_${Date.now()}`;
      localStorage.setItem(tempTokenKey, loginData.access_token);
      const walletUrl = `${window.location.origin}/customer/wallet`;
      openInNewTab(walletUrl);
    } else {
      // If no loginData, try to use stored token
      const authToken = localStorage.getItem("auth_token");
      if (authToken) {
        const tempTokenKey = `customer_temp_token_${Date.now()}`;
        localStorage.setItem(tempTokenKey, authToken);
        const walletUrl = `${window.location.origin}/customer/wallet`;
        openInNewTab(walletUrl);
      } else {
        setMessage({
          text: "Please login again to access your wallet.",
          type: "error",
        });
        clearMessageAfterDelay(5000);
      }
    }
  };

  // Safari-compatible redirect function
  const redirectToWallet = () => {
    const walletUrl = "/customer/wallet";

    // Method 1: Try standard navigation first
    try {
      navigate(walletUrl);
      return;
    } catch (error) {
      console.log("Navigate failed, trying fallback");
    }

    // Method 2: Use window.location (bypasses React Router but works in Safari)
    try {
      window.location.href = walletUrl;
      return;
    } catch (error) {
      console.log("Window location failed, trying fallback");
    }

    // Method 3: Create a temporary link click (most reliable for Safari)
    try {
      const link = document.createElement("a");
      link.href = walletUrl;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    } catch (error) {
      console.log("Link click failed, trying final fallback");
    }

    // Method 4: Final fallback - show manual link
    setMessage({
      text: "Login successful! If not redirected, please click here to go to your wallet.",
      type: "success",
    });
  };

  useEffect(() => {
    if (location.hash === "#google-login-button") {
      const el = document.getElementById("google-login-button");
      if (el) {
        const yOffset = -80;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const name = params.get("name");
    const email = params.get("email");
    const firstLogin = params.get("firstLogin") === "true";

    if (token) {
      // User just completed OAuth login
      localStorage.setItem("auth_token", token);
      localStorage.setItem("user_name", name || "");
      localStorage.setItem("user_email", email || "");
      localStorage.setItem("is_first_login", firstLogin ? "true" : "false");

      // Show success message for OAuth login
      setMessage({
        text: "Login successful! Your wallet has been opened in a new tab.",
        type: "success",
      });
      setLoginData({ access_token: token });
      clearMessageAfterDelay(15000);

      // Remove token from URL to prevent showing on refresh
      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  }, []);

  // Message style
  const messageStyle = {
    textAlign: "center",
    padding: "10px",
    borderRadius: "8px",
    margin: "10px 0",
    fontWeight: "500",
  };

  // Sliding Cards Component
  const SlidingCardsSection = () => {
    return (
      <div
        className="sliding-cards-section py-4 pt-5"
        style={{
          marginBottom: "40px",
          borderRadius: "20px",
          padding: "30px",
        }}
      >
        <div className="container">
          <h2
            className="text-center mb-4"
            style={{
              fontWeight: "bold",
              fontSize: "2.2rem",
              color: "#fff",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            Welcome to TopCoin UK - Become a Customer and Earn Commissions!
          </h2>

          <p
            className="text-center mb-5"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.1rem",
              maxWidth: "800px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Join under our Authorized Customer Ads Agents and start earning
            commissions today!
          </p>

          {/* Cards Section */}
          {!isLoadingAgents && seniorAgents.length > 0 && (
            <div
              className="position-relative"
              style={{
                maxWidth: "1000px",
                margin: "0 auto",
              }}
            >
              {/* Navigation Arrow Buttons */}
              {seniorAgents.length > 1 && (
                <>
                  <button
                    onClick={handlePrevSlide}
                    style={{
                      position: "absolute",
                      left: "-40px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                      border: "none",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                      zIndex: 10,
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
                      e.currentTarget.style.transform = "translateY(-50%)";
                    }}
                  >
                    <IoArrowBack size={24} color="#2D4CA8" />
                  </button>

                  <button
                    onClick={handleNextSlide}
                    style={{
                      position: "absolute",
                      right: "-40px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                      border: "none",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                      zIndex: 10,
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                      e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
                      e.currentTarget.style.transform = "translateY(-50%)";
                    }}
                  >
                    <IoArrowForward size={24} color="#2D4CA8" />
                  </button>
                </>
              )}

              {/* Cards Container */}
              <div
                className="sliderCard"
                style={{
                  overflow: "hidden",
                  borderRadius: "20px",
                  position: "relative",
                  height: "450px",
                }}
              >
                <div
                  className="slideCardGap"
                  style={{
                    display: "flex",
                    transform: `translateX(-${currentSlide * 320}px)`,
                    transition: "transform 0.5s ease-in-out",
                    padding: "10px",
                  }}
                >
                  {seniorAgents.map((agent, index) => (
                    <div
                      key={agent.id}
                      className="agent-card"
                      onClick={() => handleCardClick(agent.referralLink)}
                      style={{
                        flex: "0 0 300px",
                        backgroundColor: "white",
                        borderRadius: "20px",
                        overflow: "hidden",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                        position: "relative",
                        height: "420px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0, 0, 0, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0, 0, 0, 0.2)";
                      }}
                    >
                      {/* Hover Overlay with Referral Link */}
                      <div
                        className="card-overlay"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0, 26, 100, 0.9)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: 0,
                          transition: "opacity 0.3s ease",
                          padding: "20px",
                          color: "white",
                          textAlign: "center",
                          zIndex: 2,
                        }}
                      >
                        <FaLink size={40} style={{ marginBottom: "20px" }} />
                        <h4 style={{ marginBottom: "15px" }}>
                          Join Under {agent.fullName}
                        </h4>
                        <p
                          style={{
                            fontSize: "0.9rem",
                            marginBottom: "20px",
                            wordBreak: "break-all",
                            backgroundColor: "rgba(255,255,255,0.1)",
                            padding: "10px",
                            borderRadius: "8px",
                          }}
                        >
                          {agent.referralLink}
                        </p>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            onClick={(e) => handleCopyLink(agent.referralLink, e)}
                            style={{
                              backgroundColor: "#2D4CA8",
                              color: "white",
                              border: "none",
                              padding: "8px 15px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              fontSize: "0.9rem",
                            }}
                          >
                            <FaCopy /> Copy Link
                          </button>
                          <button
                            onClick={(e) => handleShareLink(agent.referralLink, e)}
                            style={{
                              backgroundColor: "#9F4AFF",
                              color: "white",
                              border: "none",
                              padding: "8px 15px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              fontSize: "0.9rem",
                            }}
                          >
                            <FaShareAlt /> Share
                          </button>
                        </div>
                      </div>

                      {/* Card Content */}
                      <div
                        style={{
                          position: "relative",
                          height: "100%",
                          padding: "25px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {/* Profile Header */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <img
                            src={agent.profilePic}
                            alt={agent.fullName}
                            style={{
                              width: "70px",
                              height: "70px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: `4px solid ${agent.color}`,
                              marginRight: "15px",
                            }}
                          />
                          <div>
                            <h3
                              style={{
                                margin: 0,
                                color: "#001964",
                                fontSize: "1.1rem",
                                fontWeight: "bold",
                              }}
                            >
                              {agent.fullName}
                            </h3>
                            <p
                              style={{
                                margin: "5px 0 0 0",
                                color: "#666",
                                fontSize: "0.9rem",
                              }}
                            >
                              {agent.location}
                            </p>
                          </div>
                        </div>

                        {/* Position Badge */}
                        <div
                          style={{
                            backgroundColor: `${agent.color}20`,
                            color: agent.color,
                            padding: "6px 12px",
                            borderRadius: "20px",
                            display: "inline-block",
                            marginBottom: "25px",
                            fontWeight: "600",
                            fontSize: "0.8rem",
                          }}
                        >
                          {agent.position}
                        </div>

                        {/* QR Code */}
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <img
                            src={agent.qrCode}
                            alt="QR Code"
                            style={{
                              width: "180px",
                              height: "180px",
                              borderRadius: "10px",
                              border: `2px solid ${agent.color}`,
                            }}
                          />
                          <p
                            style={{
                              marginTop: "15px",
                              color: "#666",
                              fontSize: "0.85rem",
                              textAlign: "center",
                            }}
                          >
                            Scan QR code to join
                          </p>
                        </div>

                        {/* Click Hint */}
                        <div
                          style={{
                            backgroundColor: "#f5f5f5",
                            padding: "12px",
                            borderRadius: "10px",
                            textAlign: "center",
                            marginTop: "auto",
                          }}
                        >
                          <p
                            style={{
                              margin: 0,
                              color: "#2D4CA8",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                            }}
                          >
                            <FaLink /> Click card to join under{" "}
                            {agent.fullName.split(" ")[0]}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Slide Indicator Dots - Only show if more than 1 card */}
              {seniorAgents.length > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  {seniorAgents.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => handleDotClick(index)}
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: "none",
                        backgroundColor: index === currentSlide ? "#2D4CA8" : "rgba(255,255,255,0.5)",
                        margin: "0 5px",
                        cursor: "pointer",
                        transition: "background-color 0.3s ease",
                      }}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Success Message with Wallet Button Component
  const SuccessMessage = () => {
    if (message.type !== "success") return null;

    return (
      <div
        style={{
          ...messageStyle,
          backgroundColor: "#e8f5e9",
          color: "#2e7d32",
          border: "1px solid #c8e6c9",
          textAlign: "center",
        }}
      >
        <p style={{ margin: "0 0 10px 0" }}>
          {message.text}
          <button
            onClick={handleDismissMessage}
            style={{
              background: "none",
              border: "none",
              color: "inherit",
              marginLeft: "10px",
              cursor: "pointer",
              float: "right",
              fontSize: "16px",
            }}
            title="Dismiss message"
          >
            ×
          </button>
        </p>
        <button
          onClick={handleOpenWallet}
          style={{
            backgroundColor: "#2D4CA8",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "14px",
            marginTop: "5px",
          }}
        >
          Open Customer Wallet in New Tab
        </button>
      </div>
    );
  };

  return (
    <Fragment>
      <div
        className="index_ico page_wrapper "
        style={{
          backgroundColor: "#001964",
          color: "#fff",
        }}
      >
        <Header />
        <main className="page_content">
          <SlidingCardsSection />
          <section className="register_section section_decoration py-5">
            <div className="container">
              <div className="row align-items-center">
                {/* LEFT SIDE CONTENT */}
                <div className="col-lg-7 mb-5 mb-lg-0 ">
                  <h1 className="fw-bold mt-5 mb-3">
                    Welcome to TopCoin UK - Where Loyalty Turns into Real
                    Rewards!
                  </h1>
                  <p>
                    Once someone joins TopCoin UK, they're given their own
                    Personal ID and Agent ID – instantly unlocking access to our
                    powerful earning system.
                  </p>
                  <h4 className="fw-bold mt-4">
                    How Agents Earn Free TopCoin:
                  </h4>
                  <p>
                    As a TopCoin UK Agent, you earn free TopCoin effortlessly
                    every time you refer someone!
                  </p>
                  <ul>
                    <li>When someone you introduce makes a purchase,</li>
                    {/* <li>And they enter your Agent ID,</li> */}
                    <li>
                      You'll instantly receive the same number of TopCoin they
                      earn – automatically!
                    </li>
                  </ul>
                  <p>
                    The more people you refer, the more your TopCoin balance
                    grows – and with it, your TopCoin wallet power. Start
                    sharing. Start earning.
                  </p>
                  <p>
                    Be the reason others discover TopCoin – and get rewarded
                    every step of the way.
                  </p>
                  <p>
                    <strong>Your loyalty is your power. Make it count.</strong>
                  </p>
                </div>

                {/* RIGHT SIDE LOGIN BOX */}
                <div className="col-lg-5" id="google-login-button">
                  <div
                    className="bg-white text-center shadow p-4 margin-top-lg"
                    style={{
                      color: "#000",
                      borderRadius: "20px",
                    }}
                  >
                    <div className="d-flex justify-content-center mb-3">
                      <img
                        src={coinIcon}
                        alt="TopCoin UK"
                        style={{ width: 150, height: 150 }}
                      />
                    </div>

                    <h4
                      className="fw-bold mb-2"
                      style={{
                        background:
                          "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        display: "inline-block",
                      }}
                    >
                      Welcome Back to
                      <br /> TopCoin UK
                    </h4>
                    <h3 className="sub-title">Enter your Email and Password</h3>

                    {/* Success Message with Wallet Button */}
                    <SuccessMessage />

                    {/* Regular Message display */}
                    {message.text && message.type !== "success" && (
                      <div
                        style={{
                          ...messageStyle,
                          backgroundColor:
                            message.type === "error" ? "#ffebee" : "#e8f5e9",
                          color:
                            message.type === "error" ? "#c62828" : "#2e7d32",
                          border:
                            message.type === "error"
                              ? "1px solid #ffcdd2"
                              : "1px solid #c8e6c9",
                        }}
                      >
                        {message.text}
                        <button
                          onClick={handleDismissMessage}
                          style={{
                            background: "none",
                            border: "none",
                            color: "inherit",
                            marginLeft: "10px",
                            cursor: "pointer",
                            float: "right",
                            fontSize: "16px",
                          }}
                          title="Dismiss message"
                        >
                          ×
                        </button>
                      </div>
                    )}

                    {/* Login Form */}
                    <form onSubmit={handleLogin} className="text-start mb-4">
                      <div className="mb-3">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "#052C65" }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control bg-white"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          disabled={isLoading}
                          style={{
                            borderRadius: "8px",
                            padding: "12px",
                            border: "1px solid #ccc",
                            color: "black",
                          }}
                        />
                      </div>

                      <div className="mb-2 position-relative">
                        <label
                          className="form-label fw-semibold"
                          style={{ color: "#052C65" }}
                        >
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            type={passwordVisible ? "text" : "password"}
                            className="form-control bg-white"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            style={{
                              borderRadius: "8px",
                              padding: "12px",
                              border: "1px solid #ccc",
                              color: "black",
                              paddingRight: "40px", // Add padding to prevent text overlap
                            }}
                          />
                          <span
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "12px",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#666",
                              zIndex: 2,
                              height: "20px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {passwordVisible ? (
                              <FaEye size={18} />
                            ) : (
                              <FaEyeSlash size={18} />
                            )}
                          </span>
                        </div>
                      </div>

                      {/* Forgot Password Link */}
                      <div className="mb-4 text-end">
                        <a
                          href="/forgot-password"
                          style={{
                            color: "#2D4CA8",
                            fontWeight: "500",
                            textDecoration: "none",
                          }}
                        >
                          Forgot Password?
                        </a>
                      </div>

                      <button
                        type="submit"
                        className="w-100 text-white fw-bold py-2"
                        disabled={isLoading}
                        style={{
                          backgroundColor: isLoading ? "#666" : "#0000A0",
                          borderRadius: "8px",
                          border: "none",
                          opacity: isLoading ? 0.7 : 1,
                          cursor: isLoading ? "not-allowed" : "pointer",
                        }}
                      >
                        {isLoading ? "Logging in..." : "Login"}
                      </button>
                    </form>

                    <div className="d-flex align-items-center justify-content-center mb-3 mt-3">
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#ddd",
                        }}
                      ></div>
                      <span className="px-2" style={{ color: "#666" }}>
                        or
                      </span>
                      <div
                        style={{
                          flex: 1,
                          height: "1px",
                          backgroundColor: "#ddd",
                        }}
                      ></div>
                    </div>

                    <div
                      className="d-flex justify-content-center"
                      style={{ gap: "12px" }}
                    >
                      {/* Google Login Button */}
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (isLoading) return;

                          // Build the Google OAuth URL with referral code
                          const callbackUrl = `${window.location.origin}/auth/google/callback`;
                          let googleAuthUrl = `${API_URL}/api/auth/google?callback=${encodeURIComponent(
                            callbackUrl
                          )}`;

                          // Add referral code if available
                          if (referralCode) {
                            googleAuthUrl += `&ref=${encodeURIComponent(
                              referralCode
                            )}`;
                            localStorage.setItem(
                              "pending_oauth_referral",
                              referralCode
                            );
                            console.log(
                              "🔗 Opening Google OAuth with referral (new tab):",
                              referralCode
                            );
                          }

                          // Use component helper to open in a new tab with fallbacks
                          openInNewTab(googleAuthUrl);
                        }}
                        disabled={isLoading}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 16px 5px 16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                      >
                        <img src={sicon1} alt="Google" width="33" height="35" />
                      </button>

                      {/* Apple Login Button */}
                      {/* <button
                        onClick={handleAppleLogin}
                        disabled={isLoading}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          border: "none",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isLoading ? "not-allowed" : "pointer",
                          opacity: isLoading ? 0.7 : 1,
                        }}
                      >
                        <img
                          src={appleIcon}
                          alt="Apple"
                          width="40"
                          height="40"
                        />
                      </button> */}
                    </div>

                    <div className="mt-4">
                      <p className="mb-0" style={{ color: "#666" }}>
                        Don't have an account yet?{" "}
                        <a
                          href={`/create-account${window.location.search}`}
                          target="_blank"
                          style={{
                            color: "#2D4AFF",
                            textDecoration: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Create Account
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </Fragment>
  );
}

export default LoginPage;